import { ATTACHMENT_SERVICE_NAME, AttachmentServiceProvider } from './attachments.service'

export const ATTACHEMNT_SERVICES_MODULE_NAME = 'simax.services.attachments'

const attachmentServicesModule = angular.module(ATTACHEMNT_SERVICES_MODULE_NAME, [])

attachmentServicesModule.provider(ATTACHMENT_SERVICE_NAME, AttachmentServiceProvider)
